/**
 * Billing Intent — No Charge reason vocabulary (single source of truth).
 *
 * Stored machine values are STABLE and must not change:
 *   warranty · callback · complimentary · internal · other
 * UI labels may differ (e.g. "callback" shows "Callback / Re-service").
 *
 * `billingIntent` on a task is either 'billable' or 'non_billable'. A MISSING
 * value is legacy/unknown and is never interpreted as billable at read time.
 */

export const NON_BILLABLE_REASONS = [
  { value: 'warranty',      label: 'Warranty' },
  { value: 'callback',      label: 'Callback / Re-service' },
  { value: 'complimentary', label: 'Complimentary' },
  { value: 'internal',      label: 'Internal / Non-Customer' },
  { value: 'other',         label: 'Other' },
];

const REASON_MAP = Object.fromEntries(NON_BILLABLE_REASONS.map((r) => [r.value, r.label]));

export const REASON_VALUES = NON_BILLABLE_REASONS.map((r) => r.value);

/** Human label for a stored reason value. Falls back to the raw value. */
export function reasonLabel(v) {
  return REASON_MAP[(v || '').toLowerCase()] || (v || '');
}

/** Only the 'other' reason requires an explanatory note. */
export function requiresNote(v) {
  return (v || '').toLowerCase() === 'other';
}
